export enum TaxReportForm {
    FORM_941 = 'FORM_941',
    FORM_940 = 'FORM_940',
    FORM_1120 = 'FORM_1120',
    FORM_1120S = 'FORM_1120S',
    FORM_1065 = 'FORM_1065',
    SALES_TAX_REPORT = 'SALES_TAX_REPORT',
    ANNUAL_REPORT = 'ANNUAL_REPORT',
}

export function getTaxReportFormLabel(form: TaxReportForm): string {
    switch (form) {
        case TaxReportForm.FORM_941: return "Form 941";
        case TaxReportForm.FORM_940: return "Form 940";
        case TaxReportForm.FORM_1120: return "Form 1120";
        case TaxReportForm.FORM_1120S: return "Form 1120S";
        case TaxReportForm.FORM_1065: return "Form 1065";
        case TaxReportForm.SALES_TAX_REPORT: return "Sales Tax Report";
        case TaxReportForm.ANNUAL_REPORT: return "Annual Report";
        default: return form;
    }
}
